export default __webpack_public_path__ + "static/media/print_order_password_2.1b9ff5b3.jpg";